import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';

export const BOOKING_CREATE_INIT = createAction('BOOKING_CREATE_INIT');
export const BOOKING_CREATE_SUCCESS = createAction('BOOKING_CREATE_SUCCESS');
export const BOOKING_CREATE_FAIL = createAction('BOOKING_CREATE_FAIL');

export const BOOKING_FETCH_INIT = createAction('BOOKING_FETCH_INIT');
export const BOOKING_FETCH_SUCCESS = createAction('BOOKING_FETCH_SUCCESS');
export const BOOKING_FETCH_FAIL = createAction('BOOKING_FETCH_FAIL');

export const BOOKING_FETCH_BY_ID_INIT = createAction(
  'BOOKING_FETCH_BY_ID_INIT'
);
export const BOOKING_FETCH_BY_ID_SUCCESS = createAction(
  'BOOKING_FETCH_BY_ID_SUCCESS'
);
export const BOOKING_FETCH_BY_ID_FAIL = createAction(
  'BOOKING_FETCH_BY_ID_FAIL'
);

export const BOOKING_UPDATE_INIT = createAction('BOOKING_UPDATE_INIT');
export const BOOKING_UPDATE_SUCCESS = createAction('BOOKING_UPDATE_SUCCESS');
export const BOOKING_UPDATE_FAIL = createAction('BOOKING_UPDATE_FAIL');

export const BOOKING_DELETE_INIT = createAction('BOOKING_DELETE_INIT');
export const BOOKING_DELETE_SUCCESS = createAction('BOOKING_DELETE_SUCCESS');
export const BOOKING_DELETE_FAIL = createAction('BOOKING_DELETE_FAIL');

export const createBooking = ({
  title,
  siteId,
  startTime,
  endTime,
  picName,
  description,
  roomIds,
}) => {
  return async (dispatch) => {
    dispatch(BOOKING_CREATE_INIT());

    try {
      const response = await Axios.post(
        `${url}/booking`,
        {
          title,
          siteId,
          startTime,
          endTime,
          picName,
          description,
          roomIds,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );

      if (response.data.error === 0) {
        dispatch(BOOKING_CREATE_SUCCESS({ booking: response.data.data }));
        toastr.success('Success', 'Booking created successfully');
        return { success: true, data: response.data.data };
      } else {
        dispatch(BOOKING_CREATE_FAIL({ error: response.data.message }));
        toastr.error('Error', response.data.message);
        return { success: false, error: response.data.message };
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to create booking';
      dispatch(BOOKING_CREATE_FAIL({ error: errorMessage }));
      toastr.error('Error', errorMessage);
      return { success: false, error: errorMessage };
    }
  };
};

export const fetchBookings = ({ startDate, endDate, search = '', roomId = '', type = 'daily', siteId, page, limit }) => {
  return async (dispatch) => {
    dispatch(BOOKING_FETCH_INIT());

    const requestData = {
      startDate,
      endDate,
      search,
      type,
    };

    if (roomId) requestData.roomId = roomId;
    if (siteId) requestData.siteId = siteId;
    if (page) requestData.page = page
    if (limit) requestData.limit = limit

    try {
      const response = await Axios.get(
        `${url}/booking`,
        {
          params: requestData,
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );

      if (response.data.error === 0) {
        dispatch(BOOKING_FETCH_SUCCESS({ bookings: response.data.data }));
        return { success: true, data: response.data.data };
      } else {
        dispatch(BOOKING_FETCH_FAIL({ error: response.data.message }));
        toastr.error('Error', response.data.message);
        return { success: false, error: response.data.message };
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to fetch bookings';
      dispatch(BOOKING_FETCH_FAIL({ error: errorMessage }));
      toastr.error('Error', errorMessage);
      return { success: false, error: errorMessage };
    }
  };
};

export const fetchBookingById = (bookingId) => {
  return async (dispatch) => {
    dispatch(BOOKING_FETCH_BY_ID_INIT());

    try {
      const response = await Axios.get(`${url}/booking/${bookingId}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
      });

      if (response.data.error === 0) {
        dispatch(BOOKING_FETCH_BY_ID_SUCCESS({ booking: response.data.data }));
        return { success: true, data: response.data.data };
      } else {
        dispatch(BOOKING_FETCH_BY_ID_FAIL({ error: response.data.message }));
        toastr.error('Error', response.data.message);
        return { success: false, error: response.data.message };
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to fetch booking';
      dispatch(BOOKING_FETCH_BY_ID_FAIL({ error: errorMessage }));
      toastr.error('Error', errorMessage);
      return { success: false, error: errorMessage };
    }
  };
};

export const updateBooking = ({
  bookingId,
  title,
  siteId,
  startTime,
  endTime,
  picName,
  description,
  roomIds,
}) => {
  return async (dispatch) => {
    dispatch(BOOKING_UPDATE_INIT());

    try {
      const response = await Axios.put(
        `${url}/booking/${bookingId}`,
        {
          title,
          siteId,
          startTime,
          endTime,
          picName,
          description,
          roomIds,
        },
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );

      if (response.data.error === 0) {
        dispatch(BOOKING_UPDATE_SUCCESS({ booking: response.data.data }));
        toastr.success('Success', 'Booking updated successfully');
        return { success: true, data: response.data.data };
      } else {
        dispatch(BOOKING_UPDATE_FAIL({ error: response.data.message }));
        toastr.error('Error', response.data.message);
        return { success: false, error: response.data.message };
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to update booking';
      dispatch(BOOKING_UPDATE_FAIL({ error: errorMessage }));
      toastr.error('Error', errorMessage);
      return { success: false, error: errorMessage };
    }
  };
};

export const deleteBooking = (bookingId, siteId) => {
  return async (dispatch) => {
    dispatch(BOOKING_DELETE_INIT());

    try {
      const response = await Axios.delete(`${url}/booking/${bookingId}`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
        },
        data: {
          siteId: siteId,
        },
      });

      if (response.data.error === 0) {
        dispatch(BOOKING_DELETE_SUCCESS({ bookingId }));
        toastr.success('Success', 'Booking deleted successfully');
        return { success: true };
      } else {
        dispatch(BOOKING_DELETE_FAIL({ error: response.data.message }));
        toastr.error('Error', response.data.message);
        return { success: false, error: response.data.message };
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        'Failed to delete booking';
      dispatch(BOOKING_DELETE_FAIL({ error: errorMessage }));
      toastr.error('Error', errorMessage);
      return { success: false, error: errorMessage };
    }
  };
};
